export default __webpack_public_path__ + "static/deek_formal-71147b061de69cc4b2d3fac12d00d07b.png";